// extracted by mini-css-extract-plugin
export var deliveryRow = "_ih-a";
export var fixedHeight = "_ih-4";
export var freightLogo = "_ih-9";
export var fullWidth = "_ih-3";
export var priceColumn = "_ih-5";
export var radioSelected = "_ih-7";
export var radioUnselected = "_ih-6";
export var selectedOption = "_ih-2";
export var selectedOptionContainer = "_ih-1";
export var selection = "_ih-0";
export var tallSkeletonText = "_ih-8";